const getStringFromCount = (count: number, str: string) => {
  if (!count) return "";
  if (count > 1) return `${count} ${str}s`;
  return `${count} ${str}`;
};

export default getStringFromCount;
